import React from 'react';
import { Avatar } from 'primereact/avatar';

const ChatList = ({ senderName, message, senderImage, lastSeen, senderOnlineStatus,isSelected,onClick }) => {
  const badgeStyle = {
    bottom: '2px',
    right: '2px',
    backgroundColor: senderOnlineStatus ? 'green' : 'grey',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  return (
    <div className={`flex flex-nowrap justify-content-between align-items-center border-bottom-1 surface-border border-round p-3 cursor-pointer select-none hover:surface-hover transition-colors transition-duration-150 ${isSelected ? 'bg-blue-500' : ''}`} style={{ marginBottom: '20px', marginLeft: '10px' }} onClick={onClick}>
      <div className="flex align-items-center">
        <div className="relative md:mr-3">
          <Avatar className="p-overlay-badge" shape="circle" image={senderImage} size="xlarge">
            <span className="w-1rem h-1rem border-circle border-2 surface-border absolute" style={badgeStyle}>
              {!senderOnlineStatus && <i className="pi pi-times"></i>}
            </span>
          </Avatar>
        </div>
        <div className="flex-column hidden md:flex">
          <span className="text-900 font-semibold block">
            {senderName}
          </span>
          <span className="block text-600 text-overflow-ellipsis overflow-hidden white-space-nowrap w-10rem text-sm">
            {message}
          </span>
        </div>
      </div>
      <span className="text-700 font-semibold ml-auto hidden md:inline">{lastSeen}</span>
    </div>
  );
};

export default ChatList;
